import { useNavigate } from "react-router-dom"
import { XCircle } from "lucide-react"
import { Button } from "@/modules/shared/ui/components/button"
import { clearPendingPaymentReturn } from "@/lib/payment-return"

export default function PaymentCancel() {
  const navigate = useNavigate()

  const handleContinue = () => {
    // Nothing was charged, so drop any remembered payment context and let the
    // user re-select an organisation.
    clearPendingPaymentReturn()
    navigate("/select-organisation", { replace: true })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-layout-bg p-6">
      <div className="max-w-md w-full bg-card rounded-2xl shadow-md border border-border p-8 text-center">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-destructive/10 mb-4">
          <XCircle className="w-8 h-8 text-destructive" />
        </div>
        <h2 className="text-2xl font-bold text-foreground">Payment Cancelled</h2>
        <p className="mt-2 text-muted-foreground">
          Your payment was cancelled. You can try again when you're ready.
        </p>
        <Button
          onClick={handleContinue}
          variant="outline"
          className="mt-6 w-full"
        >
          Select Organisation
        </Button>
      </div>
    </div>
  )
}
